import './list.less';
import PropTypes from 'prop-types';
import React from 'react';
import ClickOutside from 'react-onclickoutside';
import cn from 'classname';

import Select from '../../../shared/form-elements/select/select';

const propTypes = {
	listOfFilters: PropTypes.array,
	addFilter: PropTypes.func,
	showListOfFilters: PropTypes.bool,
	hideFiltersList: PropTypes.func,
	intl: PropTypes.func,
	prepareFiltersList: PropTypes.func
};

class List extends React.Component {
	render() {
		return (
			<div className="filters__list-wrap filters__left">
				<div className="filters__list">
					<div className={cn({
						'form-element-select': true
					})}>
						<Select
							placeholder={this.props.intl('Select filters')}
							options={this.props.prepareFiltersList(this.props.listOfFilters) }
							searchable={true}
							multi={false}
							name='filtersList'
							shouldOpenOptions={true}
							isFilterSelect={true}
							onChange={value => {
								if (value[0] && value[0]['value']) {
									this.props.addFilter(
										value[0]['value'],
										value[0]['value']!=='affiliateRegistrationDate'
									);
								}
							}} />
					</div>
				</div>
			</div>
		);
	}

	handleClickOutside(e) {
		if (this.props.showListOfFilters) {
			this.props.hideFiltersList();
		}
	}
}

List.propTypes = propTypes;

export default ClickOutside(List);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/filters/components/list.js